export default __webpack_public_path__ + "static/media/ISO.36b53fac.png";